module.exports = __webpack_public_path__ + "img/beckon_ios_802.png";